import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import rolesI18N from 'i18n/roles/es.json';
import commonI18N from 'i18n/common/es.json';
import { rolesActions } from 'core/services/roles';
import { formatErrorMessage } from 'core/util';

export let RolFormComponent = {
  templateUrl: template,
  selector: 'rolForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(rolesI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', '$timeout', 'Filter', '$scope'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, $timeout, Filter, $scope) {
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.loadPermissions = loadPermissions.bind(this);
  this.updatePermisosMap = updatePermisosMap.bind(this);
  this.toggleSelectedPermission = toggleSelectedPermission.bind(this);
  this.searchPermissions = searchPermissions.bind(this);
  this.changeSearch = changeSearch.bind(this);
  this.filterModules = filterModules.bind(this);
  // this.updateAssignedCount = updateAssignedCount.bind(this);
  this.permisosMap = {};
  this.allPermissionsMap = {}; // cachea todos los permisos asociados al modulo
  // almacena los permisos seleccionados, pero no se tiene en cuenta para la logica de la interfaz.
  this.selectedPermissionsHelper = {};
  const actions = Object.assign({}, FormActions, rolesActions);

  this.$onInit = () => {
    this.unsubscribe = $ngRedux.connect(this.mapStateToThis, actions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver rol'] : this.translations['Editar rol'];
      this.formEdit('roles', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo rol'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.modulos.get());
    // limpiamos lo que pudo haberse cacheado en el state anteriormente
    $ngRedux.dispatch(rest.actions.permisosPorModulo.reset());
    $ngRedux.dispatch(rest.actions.permisos.reset());
    $ngRedux.dispatch(rolesActions.initPermissionsSelection());
  };

  this.$onDestroy = () => {
    this.form();
    this.unsubscribe();
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.model = state.form.model;

    if (this.model && this.model.permisos && !this.permisosPreloaded) {
      this.permisosPreloaded = true;
      $ngRedux.dispatch(rolesActions.togglePermissions(this.model.permisos));
    }

    if (state.modulos) {
      this.modulos = state.modulos.data;
    }

    if (state.permisosPorModulo) {
      this.updatePermisosMap(state.permisosPorModulo.data);
    }

    if (state.permisos && state.permisos.data.length > 0) {
      this.filterModules(state.permisos.data);
    }
    if (state.permisos && state.permisos.data && this.searching) {
      this.sinResultados = false;
      if (state.permisos.data.length > 0) {
        this.searching = false;
        this.filterModules(state.permisos.data);
      } else {
        this.sinResultados = true;
      }
    }

    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.selectedPermissionsHelper = Object.assign({}, state.rolesForm.selectedPermissions);
    return {
      form: state.form,
      selectedPermissions: state.rolesForm.selectedPermissions,
      assignedCounts: state.rolesForm.assignedCounts
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.roles.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.roles.list');
    }
  }


  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.roles.list');
  }

  function doSubmit() {
    if ($scope.rolForm.$invalid) {
      this.submitted = true;
      return;
    }

    var data = Object.assign({}, this.model);
    data.permisos = Object.keys(this.selectedPermissions)
      .filter((id) => this.selectedPermissions[id])
      .map((id) => parseInt(id));

    if (!data.permisos.length && !this.model.assignAll) {
      ngNotify.set(this.translations['Debe seleccionar al menos un permiso'], 'warn');
      return;
    }

    this.save('roles', data);
  }

  /**
   * Se encarga de cargar los permisos asociados al modulo seleccionado.
   * 
   * @param {number} moduloId
   */
  function loadPermissions(moduloId) {
    if (this.searching) {
      return;
    }
    $ngRedux.dispatch(rest.actions.permisosPorModulo({ id: moduloId }));
  }

  /**
   * Actualiza el map de permisos a partir de los registros dados como parametro.
   * 
   * @param {object[]} permisos
   */
  function updatePermisosMap(permisos) {
    if (!permisos || permisos.length === 0) {
      return;
    }
    const moduloId = permisos[0].modulo.id;
    this.permisosMap[moduloId] = permisos;
    this.allPermissionsMap[moduloId] = permisos;
  }


  /**
   * se encarga de seleccionar/deseleccionar el permiso
   * 
   * @param {number} mid - El ID del modulo.
   * @param {number} pid - El ID del permiso.
   */
  function toggleSelectedPermission(mid, pid) {
    $ngRedux.dispatch(rolesActions.togglePermission(mid, pid));
  }

  /**
   * Llama al endpoint /permisos del backend con el filtro dado 
   * como parámetro.
   * 
   * @param {string} search
   */
  function changeSearch(search) {
    if (!search) {
      // si hace reset del query de busqueda, debemos resetear los valores filtrados.
      this.permisosMap = _.clone(this.allPermissionsMap);
      $ngRedux.dispatch(rest.actions.modulos.get());
      $ngRedux.dispatch(rest.actions.permisosPorModulo.reset());
      $ngRedux.dispatch(rest.actions.permisos.reset());
      this.searching = false;
      this.sinResultados = false;
      return;
    }
  }


  function searchPermissions(search) {
    if (!search) {
      // si hace reset del query de busqueda, debemos resetear los valores filtrados.
      this.permisosMap = _.clone(this.allPermissionsMap);
      $ngRedux.dispatch(rest.actions.modulos.get());
      $ngRedux.dispatch(rest.actions.permisosPorModulo.reset());
      $ngRedux.dispatch(rest.actions.permisos.reset());
      this.searching = false;
      return;
    }

    this.searching = true;
    const filter = Filter.path('descripcion').like(search)
      .or(Filter.path('nombre').like(search))
      .or(Filter.path('modulo.name').like(search));

    $ngRedux.dispatch(rest.actions.permisos.get({ filter: JSON.stringify(filter) }));
  }

  /**
   * Se encarga de filtrar la lista de modulos, a partir de los permisos 
   * resultados de la busqueda.
   * 
   * @param {object[]} permissions
   */
  function filterModules(permissions) {
    // verificamos los callbacks que quedaron pendientes en searchPermission
    // if (this.searching) {
    //   return;
    // }
    this.searchedPermissions = permissions;
    this.modulos = _.unique(permissions.map((permiso) => permiso.modulo), (modulo) => modulo.id);
    console.log(this.modulos);
    this.modulos.forEach((modulo) => {
      this.permisosMap[modulo.id] = permissions.filter((permiso) => permiso.modulo.id === modulo.id);
    });
    console.log(this.permisosMap);
  }
}


// WEBPACK FOOTER //
// ./src/components/roles/form/form.component.js